/* Product Tile Markup - You can play around with this to change the
information that appears on the Wishlisted Product tiles  */
var productCardMarkup = 
  `
	<div class="swym-ui-component">
		<div class="swym-wishlist-detail">
			<div class="c-swym-wishlist-bulk-add-toCartBtn__wrapper">
				<button type="button" onclick="addToCartInBulk(event)" class="c-swym-wishlist-bulk-add-toCartBtn button button--secondary">全てカートに入れる</button>
			</div>
			<div class="swym-wishlist-grid c-swym-wishlist-grid">
				{{#products}} 
				<a href="{{du}}"aria-label="{{dt}}" data-available="{{available}}" data-compare_at_price_varies="{{compare_at_price_varies}}" class="swym-wishlist-item swym-is-anchor"><button id="swym-remove-productBtn" aria-label="Delete" data-variant-id="{{epi}}" data-product-id="{{empi}}" data-product-url="{{du}}" class="swym-delete-btn swym-nav swym-nav-1 swym-is-button"><span class="swym-icon"></span></button>
					<div class="swym-wishlist-image-wrapper"><img alt="" class="swym-wishlist-image" src="{{iu}}"></div><button class="swym-is-button">
					<div class="swym-title swym-title-1">
						{{dt}}
					</div></button>
					<div class="swym-variant-title swym-text swym-title-2 swym-variant-title-spacer hidden">
						{{variantinfo}}
					</div>
					<div class="swym-product-price swym-text swym-text-1">
						<div class="swym-product-final-price swym-value">
							{{cu}}{{pr}}
						</div>
					</div>
					<div class="swym-product-price swym-has-sale swym-text swym-text-1">
						<div class="swym-product-final-price swym-value">
							{{cu}}{{pr}}
						</div>
						<div class="swym-product-original-price swym-value">
							{{cu}}{{compare_at_price}}
						</div>
					</div>
					<button id="swym-custom-add-toCartBtn" data-state-cart="{{#isInCart}}swym-added{{/isInCart}}"data-product-url="{{du}}" data-variant-id="{{epi}}" data-product-id="{{empi}}"class="swym-add-to-cart-btn swym-button swym-button-1 swym-is-button swym-is-button">
						{{#isInCart}}カートに追加済み{{/isInCart}}{{^isInCart}}カートに入れる{{/isInCart}}
					</button>
					<button class="swym-add-to-cart-btn swym-button swym-button-1 swym-is-button swym-bg-2 swym-color-4 swym-is-button swym-disabled" disabled>
						売り切れ
					</button>
				</a> 
				{{/products}}
			</div>
		</div>
	</div>
	`;

// 2023.5.18 Add  : Hidden add to cart if products with specific tags
const addToCartBtnControl = (products) => {
	const hiddenBtnItems = products.filter(product => product.tags.includes("株主優待品") || product.tags.includes("type_直営店限定") || product.tags.includes("wrapping_noshi") || product.tags.includes("名入れ_ひらがな") || product.tags.includes("名入れ_アルファベット") || product.tags.includes("名入れ_イニシャル") || product.tags.includes("名入れ_兜"))
	//スタイルシートを生成し適用
	let styleSheet = document.createElement("style");
	styleSheet.id = "custom-add-btn-control"
	document.querySelector('.c-account-content').appendChild(styleSheet);
	
	// 特定タグを含む商品がある場合、ボタン非表示処理
	if(hiddenBtnItems.length > 0){
		// 非表示タグラベル (aria-label="26.5cmプレート - Default Title")
		hiddenBtnItems.forEach((hiddenItem,index) => {
			styleSheet.sheet.insertRule(`.swym-wishlist-item[aria-label*="${hiddenItem.title}"] .swym-add-to-cart-btn{display:none !important;}`,index);
		})
		// 全てカートに入れるボタンを非表示
		styleSheet.sheet.insertRule(`.c-swym-wishlist-bulk-add-toCartBtn__wrapper{display:none !important;}`,hiddenBtnItems.length);
	}
}

// Add to cart in bulk
function addToCartInBulk(event){
	event.target.setAttribute("disabled",true);
	const enableProductItems = itemMetaInfoList.filter(item => item.available === true);
	const formData = {
		items:enableProductItems.map(productItem => {
			return {
				id:productItem.variants[0].id,
				quantity:1
			}
		})
	}

	fetch('/cart/add.js', {
			method: 'POST',
			headers: {
				'dataType': 'json',
				'Content-Type': 'application/json'
			},
			body: JSON.stringify(formData)
		})
		.then(response => response.json())
		.then(data => {
			if (data && typeof data.items === 'undefined') {
				alert("在庫を超えて購入できない商品がありました");
			}else{
				console.log(data)
				window.location.href="/cart";
			}
		})
		.catch((error) => {
			alert("在庫を超えて購入できない商品がありました");
			console.error('Error:', error);
		});
}

function getVariantInfo(variants) {
	try {
		let variantKeys = ((variants && variants != "[]") ? Object.keys(JSON.parse(variants)[0]) : []),
			variantinfo;
		if (variantKeys.length > 0) {
			variantinfo = variantKeys[0];
			if (variantinfo == "Default Title") {
				variantinfo = "";
			}
		} else {
			variantinfo = "";
		}
		return variantinfo;
	} catch (err) {
		return variants;
	}
}


let itemMetaInfoList = [];

function getJSON(url, qs_params) {
	function buildQueryString(params) {
		return Object.entries(params).map(d => `${d[0]}=${d[1]}`).join('&');
	}

	return new Promise((resolve, reject) => {
		const qs = qs_params ? '?' + buildQueryString(qs_params) : '';
		const xhr = new XMLHttpRequest();
		xhr.open('GET', `${url}${qs}`);

		xhr.onload = function() {
			if (xhr.status >= 200 && xhr.status < 400) {
				resolve(JSON.parse(xhr.responseText));
			} else {
				resolve(xhr.responseText);
			}
		};
		xhr.onerror = () => reject(xhr.statusText);
		xhr.send();
	});
}

function fetchProduct(productItem) {
	return new Promise(resolve => {
		const requestOptions = {
			method: 'GET',
			redirect: 'follow'
		};
		getJSON(`${productItem.du}.js?${requestOptions}`)
			.then((response) => {
				resolve(response);
			})
			.catch((error) => {
				resolve(productItem);
			});
	})
}

async function getProductInfo(products) {
	const fetchProducts = products.map(product => fetchProduct(product));

	await Promise.all(fetchProducts)
		.then( (result) => {
			itemMetaInfoList = result;
			return true; 
		} ) 
		.catch( function (error) {
			itemMetaInfoList = products;
			console.error(error);
			return true; 
		} ) ;
}

function swymRenderWishlist(swat) {
	// Get wishlist items
	swat.fetch(function(products) {
		getProductInfo(products).then(result => {
			var wishlistContentsContainer = document.getElementById("wishlist-items-container");
			var formattedWishlistedProducts = products.map(function(p) {
				p = SwymUtils.formatProductPrice(p); // formats product price and adds currency to product Object
				p.pr = Number.parseInt(p.pr).toLocaleString();
				p.isInCart = _swat.platform.isInDeviceCart(p.epi) || (p.et == _swat.EventTypes.addToCart);
				p.variantinfo = (p.vi ? getVariantInfo(p.vi) : "");
				// Start : getProductInfo()で取得した商品情報を追記する
				var productMetaInfo = itemMetaInfoList.find(metaInfo => metaInfo.id === p.empi);
				p.available = (productMetaInfo ? productMetaInfo.available : false);
				p.compare_at_price_varies = (productMetaInfo && productMetaInfo.compare_at_price !== null ? true : false);
				p.compare_at_price = (productMetaInfo && productMetaInfo.compare_at_price ? (Number.parseInt(SwymUtils.formatProductPrice(productMetaInfo.compare_at_price)) / 100).toLocaleString() : "");
				// End : getProductInfo()
				return p;
			});
			var productCardsMarkup = SwymUtils.renderTemplateString(productCardMarkup, {
				products: formattedWishlistedProducts
			});

				// 購入ボタンの表示制御 : addToCartBtnControl()
				addToCartBtnControl(itemMetaInfoList);
			if(wishlistContentsContainer){
				wishlistContentsContainer.innerHTML = productCardsMarkup;
				attachClickListeners();
			} else{
				console.log("Container not found, Wishlist Page element not found");
			}
		});

	});
}

function onAddToCartClick(e) {
	e.preventDefault();
	var productId = e.currentTarget.getAttribute("data-product-id");
	var variantId = e.currentTarget.getAttribute("data-variant-id");
	var du = e.target.getAttribute("data-product-url");
	e.target.innerHTML = "Adding..";
	window._swat.replayAddToCart({
		empi: productId,
		du: du
	}, variantId, function(c) {
		e.target.innerHTML = "Added to Cart";
		e.target.setAttribute("data-state-cart", "swym-added");
		console.log("Successfully added product to cart.", c);
	}, function(e) {
		console.log(e);
	});
}

function attachClickListeners() {
	var addToCartButtons = document.querySelectorAll("#swym-custom-add-toCartBtn");
	var removeBtns = document.querySelectorAll("#swym-remove-productBtn");
	//   Add to cart Btns
	for (var i = 0; i < addToCartButtons.length; i++) {
		addToCartButtons[i].addEventListener('click', onAddToCartClick, false);
	}
	//   Remove Buttons
	for (var k = 0; k < removeBtns.length; k++) {
		removeBtns[k].addEventListener('click', onRemoveBtnClick, false);
	}
	console.log("Events attached!");
}

function onRemoveBtnClick(e) {
  e.preventDefault();
  var epi = +e.currentTarget.getAttribute("data-variant-id");
  var empi = +e.currentTarget.getAttribute("data-product-id");
  var du = e.currentTarget.getAttribute("data-product-url");

  let product = {
    epi: epi, // variant id
    empi: empi, // product Id
    du: du, // cannonical product url
  };

  let deletebutton = e.currentTarget;
  let deleteProduct = deletebutton.parentElement;
  deleteProduct.remove(); // removes product tile from DOM

	// Delete from multi lists
	// Define success and error callback functions
	let successCallBackFn = function(lists) {
		let productMultiLists = [];
		// successfully fetched my lists 
		lists.forEach(list => {
			let deleteItem = list.listcontents.find(content => content.empi === product.empi && content.epi === product.epi);
			if(deleteItem){
				productMultiLists.push(list.lid)
			}
		});

		if(productMultiLists.length > 0){
			window._swat.removeProductFromLists(product, productMultiLists, function(removedProduct){
				// successfully removed list item from the all of the arrayOfListId
				console.log("Success! removed the product from provided lists",removedProduct);
			}, function(xhrObject) {
				// something went wrong
				console.log("Error",xhrObject);
			});
		}
	}
	let errorCallBackFn = function(xhrObj) {
		// something went wrong 
	}

	// call fetchLists
	window._swat.fetchLists({
		callbackFn: successCallBackFn,
		errorFn: errorCallBackFn
	});

	// BK : アプリ会社対応前
	// e.preventDefault();
	// var epi = +e.currentTarget.getAttribute("data-variant-id");
	// var empi = +e.currentTarget.getAttribute("data-product-id");
	// window._swat.fetch(function(products) {
	// 	products.forEach(function(product) {
	// 		if (epi && empi && product.epi == epi && product.empi == empi) {
	// 			window._swat.removeFromWishList(product, function() {
	// 				if (!window.SwymCallbacks) {
	// 					window.SwymCallbacks = [];
	// 				}
	// 				window.SwymCallbacks.push(swymRenderWishlist);
	// 			});
	// 		}
	// 	});
	// })
}


if (!window.SwymCallbacks) {
	window.SwymCallbacks = [];
}
window.SwymCallbacks.push(swymRenderWishlist); /* Init Here */